{
  "title": "इनबॉक्स",
  "totalBadge": "{{count}} आइटम",
  "viewAll": "सभी देखें",
  "loading": "लोड हो रहा है…",
  "emptySection": "सब निपट गया",
  "loadError": "यह भाग लोड नहीं हो सका"
}
